import React from 'react';

import ChildrenPropType from 'lib/CustomPropTypes/children';

function Rail(props) {
  const { children } = props;

  return (
    <div className="today-cover-tabbed__rail">
      <div className="today-cover-tabbed__rail-icon" />
      { children }
    </div>
  );
}

Rail.propTypes = {
  children: ChildrenPropType.isRequired,
};

export default Rail;
